
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function ProcessSteps() {
  const heading = useFadeIn({ direction: 'up' });
  const step1 = useFadeIn({ direction: 'up', delay: 100 });
  const step2 = useFadeIn({ direction: 'up', delay: 200 });
  const step3 = useFadeIn({ direction: 'up', delay: 300 });

  return (
    <section className="py-32 md:py-40 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto space-y-20">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="text-2xl md:text-3xl font-normal text-gray-900 leading-relaxed tracking-wide text-center font-serif">
            来院後の流れ
          </h2>
        </div>
        
        <div className="space-y-16">
          <div ref={step1.ref} style={step1.style} className="space-y-6">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center">
                <span className="text-3xl font-light text-gray-400">01</span>
              </div>
              <div className="flex-1 space-y-4 pt-2">
                <h3 className="text-xl md:text-2xl font-normal text-gray-900 font-serif">
                  カウンセリング・精密検査(無料)
                </h3>
                <p className="text-gray-700 text-sm md:text-base font-light leading-loose">
                  今の悩みや生活背景を、丁寧に伺います。
                </p>
                <div className="w-full aspect-[16/9] overflow-hidden rounded-lg mt-4">
                  <img
                    src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/8882b5d0ac808adf5e46ca2b788d0c57.png"
                    alt="カウンセリング・精密検査"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div ref={step2.ref} style={step2.style} className="space-y-6 bg-white p-6 md:p-12">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center">
                <span className="text-3xl font-light text-gray-900">02</span>
              </div>
              <div className="flex-1 space-y-6 pt-2">
                <h3 className="text-xl md:text-2xl font-normal text-gray-900 font-serif">
                  院内での精密分析・診断・治療設計の作成
                </h3>
                
                <div className="py-8 space-y-6">
                  <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-gray-400">
                    <div className="flex flex-col items-center gap-3">
                      <div className="w-12 h-12 flex items-center justify-center">
                        <i className="ri-file-list-3-line text-3xl"></i>
                      </div>
                      <span className="text-xs">検査データ</span>
                    </div>
                    
                    <div className="w-8 h-0.5 bg-gray-300"></div>
                    
                    <div className="flex flex-col items-center gap-3">
                      <div className="w-12 h-12 flex items-center justify-center">
                        <i className="ri-search-line text-3xl"></i>
                      </div>
                      <span className="text-xs">分析</span>
                    </div>
                    
                    <div className="w-8 h-0.5 bg-gray-300"></div>
                    
                    <div className="flex flex-col items-center gap-3">
                      <div className="w-12 h-12 flex items-center justify-center">
                        <i className="ri-draft-line text-3xl"></i>
                      </div>
                      <span className="text-xs">診断</span>
                    </div>
                  </div>
                </div>
                
                <p className="text-gray-600 text-sm md:text-base font-light leading-loose">
                  一般的には有料級となる内容の精密分析を行い、診断結果をまとめ、<br />
                  レポートの作成を行います（無料）。
                </p>
              </div>
            </div>
          </div>
          
          <div ref={step3.ref} style={step3.style} className="space-y-6">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center">
                <span className="text-3xl font-light text-gray-400">03</span>
              </div>
              <div className="flex-1 space-y-4 pt-2">
                <h3 className="text-xl md:text-2xl font-normal text-gray-900 font-serif">
                  診断結果と選択肢の共有
                </h3>
                <p className="text-gray-700 text-sm md:text-base font-light leading-loose">
                  歯並びの詳細な診断結果をお伝えして、矯正治療を行う場合の費用・期間の目安などを詳細にお伝えします。診断結果は資料にてお渡しし、他院の相談時にも参考にすることができます。
                </p>
                <div className="w-full aspect-[16/9] overflow-hidden rounded-lg mt-4">
                  <img
                    src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/6b9c40483d52830fc3f4468665167e1a.png"
                    alt="診断結果と選択肢の共有"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
